<template>
  <div class="m-10 auth-page"> Super 角色可见 </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue';
  export default defineComponent({});
</script>
<style lang="less" scoped>
  .auth-page {
    display: flex;
    height: 300px;
    font-size: 24px;
    color: #fff;
    background-color: #409efe;
    border-radius: 12px;
    justify-content: center;
    align-items: center;
  }
</style>
